import { determineRequiredDurationValues } from './determineRequiredDurationValues';
import { IFormatsItem, ITimerSubscribeOptions } from '../interfaces';

export const createFormatsList = (format: ITimerSubscribeOptions['format']): IFormatsItem[] => {
    const formats = typeof format === 'string' ? { 0: format } : format;

    const formatsList = Object.entries(formats)
        .map(([key, value]) => ({
            second: Number(key),
            requiredDurationValues: determineRequiredDurationValues(value),
        }))
        .sort((a, b) => b.second - a.second);

    if (formatsList[formatsList.length - 1].second !== 0) {
        formatsList.push({
            second: 0,
            requiredDurationValues: formatsList[formatsList.length - 1].requiredDurationValues,
        });
    }

    return formatsList;
};
